import { TICKET_FILE_TYPES } from '../../../constants/actionTypes/ticketActionTypes';


export const initialState = {
    attachments: [],
    uploading: false,
    uploadSuccess: false,
    uploadError: false,
    deleting: false,
    deleteSuccess: false,
    deleteError: false,
};
   
export default function(state = initialState, action = {}) {
    switch (action.type) {
        case TICKET_FILE_TYPES.GET_FILE_REQUEST:
            return {
                ...state,
                attachments: []
            };
        case TICKET_FILE_TYPES.GET_FILE_SUCCESS:
        case TICKET_FILE_TYPES.GET_FILE_ERROR:
            return {
                ...state,
                attachments: action.payload
            };
        case TICKET_FILE_TYPES.POST_FILE_REQUEST:
            return {
                ...state,
                uploading: true,
                uploadSuccess: false,
                uploadError: false,
                deleting: false,
                deleteSuccess: false,
                deleteError: false,
            }; 
        case TICKET_FILE_TYPES.POST_FILE_SUCCESS:
            return {
                ...state,
                uploading: false,
                uploadSuccess: action.payload,
                uploadError: false,
            };
        case TICKET_FILE_TYPES.POST_FILE_ERROR:
            return {
                ...state,
                uploading: false,
                uploadSuccess: false,
                uploadError: action.payload,
            };
        case TICKET_FILE_TYPES.DELETE_FILE_REQUEST:
            return {
                ...state,
                deleting: true,
                deleteSuccess: false,
                deleteError: false,
                uploading: false,
                uploadSuccess: false,
                uploadError: false,
            };
        case TICKET_FILE_TYPES.DELETE_FILE_SUCCESS:
            return {
                ...state,
                deleting: false,
                deleteSuccess: action.payload,
                deleteError: false,
            };
        case TICKET_FILE_TYPES.DELETE_FILE_ERROR:
            return {
                ...state,
                deleting: false,
                deleteSuccess: false,
                deleteError: action.payload,
            };      
        default:
            return state;
    }
}
   